import _defineProperty from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { QueryBuilder } from "./QueryBuilder";
import { UpdateResult } from "./result/UpdateResult";
import { ReturningStatementNotSupportedError } from "../error/ReturningStatementNotSupportedError";
import { ReturningResultsEntityUpdator } from "./ReturningResultsEntityUpdator";
import { LimitOnUpdateNotSupportedError } from "../error/LimitOnUpdateNotSupportedError";
import { UpdateValuesMissingError } from "../error/UpdateValuesMissingError";
import { TypeORMError } from "../error";
import { EntityPropertyNotFoundError } from "../error/EntityPropertyNotFoundError";
import { DriverUtils } from "../driver/DriverUtils";
/**
 * Allows to build complex sql queries in a fashion way and execute those queries.
 */
export var UpdateQueryBuilder = /*#__PURE__*/function (_QueryBuilder) {
  _inherits(UpdateQueryBuilder, _QueryBuilder);
  var _super = _createSuper(UpdateQueryBuilder);
  // -------------------------------------------------------------------------
  // Constructor
  // -------------------------------------------------------------------------
  function UpdateQueryBuilder(connectionOrQueryBuilder, queryRunner) {
    var _this;
    _classCallCheck(this, UpdateQueryBuilder);
    _this = _super.call(this, connectionOrQueryBuilder, queryRunner);
    _this["@instanceof"] = Symbol.for("UpdateQueryBuilder");
    _this.expressionMap.aliasNamePrefixingEnabled = false;
    return _this;
  }
  // -------------------------------------------------------------------------
  // Public Implemented Methods
  // -------------------------------------------------------------------------
  /**
   * Gets generated SQL query without parameters being replaced.
   */
  _createClass(UpdateQueryBuilder, [{
    key: "getQuery",
    value: function getQuery() {
      var sql = this.createComment();
      sql += this.createCteExpression();
      sql += this.createUpdateExpression();
      sql += this.createOrderByExpression();
      sql += this.createLimitExpression();
      return sql.trim();
    }
    /**
     * Executes sql generated by query builder and returns raw database results.
     */
  }, {
    key: "execute",
    value: function () {
      var _execute = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var queryRunner, transactionStartedByUs, declareSql, selectOutputSql, returningResultsEntityUpdator, returningColumns, _iterator, _step, columnPath, _this$getQueryAndPara, _this$getQueryAndPara2, updateSql, parameters, statements, queryResult, updateResult;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              queryRunner = this.obtainQueryRunner();
              transactionStartedByUs = false;
              _context.prev = 2;
              if (!(this.expressionMap.useTransaction === true && queryRunner.isTransactionActive === false)) {
                _context.next = 7;
                break;
              }
              _context.next = 6;
              return queryRunner.startTransaction();
            case 6:
              transactionStartedByUs = true;
            case 7:
              if (!(this.expressionMap.callListeners === true && this.expressionMap.mainAlias.hasMetadata)) {
                _context.next = 10;
                break;
              }
              _context.next = 10;
              return queryRunner.broadcaster.broadcast("BeforeUpdate", this.expressionMap.mainAlias.metadata, this.expressionMap.valuesSet);
            case 10:
              declareSql = null;
              selectOutputSql = null; // if update entity mode is enabled we may need extra columns for the returning statement
              returningResultsEntityUpdator = new ReturningResultsEntityUpdator(queryRunner, this.expressionMap);
              returningColumns = [];
              if (Array.isArray(this.expressionMap.returning) && this.expressionMap.mainAlias.hasMetadata) {
                _iterator = _createForOfIteratorHelper(this.expressionMap.returning);
                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    columnPath = _step.value;
                    returningColumns.push.apply(returningColumns, _toConsumableArray(this.expressionMap.mainAlias.metadata.findColumnsWithPropertyPath(columnPath)));
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }
              }
              if (this.expressionMap.updateEntity === true && this.expressionMap.mainAlias.hasMetadata && this.expressionMap.whereEntities.length > 0) {
                this.expressionMap.extraReturningColumns = returningResultsEntityUpdator.getUpdationReturningColumns();
                returningColumns.push.apply(returningColumns, _toConsumableArray(this.expressionMap.extraReturningColumns.filter(function (c) {
                  return !returningColumns.includes(c);
                })));
              }
              if (returningColumns.length > 0 && this.connection.driver.options.type === "mssql") {
                declareSql = this.connection.driver.buildTableVariableDeclaration("@OutputTable", returningColumns);
                selectOutputSql = "SELECT * FROM @OutputTable";
              }
              // execute update query
              _this$getQueryAndPara = this.getQueryAndParameters(), _this$getQueryAndPara2 = _slicedToArray(_this$getQueryAndPara, 2), updateSql = _this$getQueryAndPara2[0], parameters = _this$getQueryAndPara2[1];
              statements = [declareSql, updateSql, selectOutputSql];
              _context.next = 21;
              return queryRunner.query(statements.filter(function (sql) {
                return sql != null;
              }).join(";\n\n"), parameters, true);
            case 21:
              queryResult = _context.sent;
              updateResult = UpdateResult.from(queryResult); // if we are updating entities and entity updation is enabled we must update some of entity columns (like version, update date, etc.)
              if (!(this.expressionMap.updateEntity === true && this.expressionMap.mainAlias.hasMetadata && this.expressionMap.whereEntities.length > 0)) {
                _context.next = 26;
                break;
              }
              _context.next = 26;
              return returningResultsEntityUpdator.update(updateResult, this.expressionMap.whereEntities);
            case 26:
              if (!(this.expressionMap.callListeners === true && this.expressionMap.mainAlias.hasMetadata)) {
                _context.next = 29;
                break;
              }
              _context.next = 29;
              return queryRunner.broadcaster.broadcast("AfterUpdate", this.expressionMap.mainAlias.metadata, this.expressionMap.valuesSet);
            case 29:
              if (!transactionStartedByUs) {
                _context.next = 32;
                break;
              }
              _context.next = 32;
              return queryRunner.commitTransaction();
            case 32:
              return _context.abrupt("return", updateResult);
            case 35:
              _context.prev = 35;
              _context.t0 = _context["catch"](2);
              if (!transactionStartedByUs) {
                _context.next = 45;
                break;
              }
              _context.prev = 38;
              _context.next = 41;
              return queryRunner.rollbackTransaction();
            case 41:
              _context.next = 45;
              break;
            case 43:
              _context.prev = 43;
              _context.t1 = _context["catch"](38);
            case 45:
              throw _context.t0;
            case 46:
              _context.prev = 46;
              if (!(queryRunner !== this.queryRunner)) {
                _context.next = 50;
                break;
              }
              _context.next = 50;
              return queryRunner.release();
            case 50:
              return _context.finish(46);
            case 51:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[2, 35, 46, 51], [38, 43]]);
      }));
      function execute() {
        return _execute.apply(this, arguments);
      }
      return execute;
    }() // -------------------------------------------------------------------------
    // Public Methods
    // -------------------------------------------------------------------------
    /**
     * Values needs to be updated.
     */
  }, {
    key: "set",
    value: function set(values) {
      this.expressionMap.valuesSet = values;
      return this;
    }
    /**
     * Sets WHERE condition in the query builder.
     * If you had previously WHERE expression defined,
     * calling this function will override previously set WHERE conditions.
     * Additionally you can add parameters used in where expression.
     */
  }, {
    key: "where",
    value: function where(_where, parameters) {
      this.expressionMap.wheres = []; // don't move this block below since computeWhereParameter can add where expressions
      var condition = this.getWhereCondition(_where);
      if (condition) this.expressionMap.wheres = [{
        type: "simple",
        condition: condition
      }];
      if (parameters) this.setParameters(parameters);
      return this;
    }
    /**
     * Adds new AND WHERE condition in the query builder.
     * Additionally you can add parameters used in where expression.
     */
  }, {
    key: "andWhere",
    value: function andWhere(where, parameters) {
      this.expressionMap.wheres.push({
        type: "and",
        condition: this.getWhereCondition(where)
      });
      if (parameters) this.setParameters(parameters);
      return this;
    }
    /**
     * Adds new OR WHERE condition in the query builder.
     * Additionally you can add parameters used in where expression.
     */
  }, {
    key: "orWhere",
    value: function orWhere(where, parameters) {
      this.expressionMap.wheres.push({
        type: "or",
        condition: this.getWhereCondition(where)
      });
      if (parameters) this.setParameters(parameters);
      return this;
    }
    /**
     * Sets WHERE condition in the query builder with a condition for the given ids.
     * If you had previously WHERE expression defined,
     * calling this function will override previously set WHERE conditions.
     */
  }, {
    key: "whereInIds",
    value: function whereInIds(ids) {
      return this.where(this.getWhereInIdsCondition(ids));
    }
    /**
     * Adds new AND WHERE with conditions for the given ids.
     */
  }, {
    key: "andWhereInIds",
    value: function andWhereInIds(ids) {
      return this.andWhere(this.getWhereInIdsCondition(ids));
    }
    /**
     * Adds new OR WHERE with conditions for the given ids.
     */
  }, {
    key: "orWhereInIds",
    value: function orWhereInIds(ids) {
      return this.orWhere(this.getWhereInIdsCondition(ids));
    }
    /**
     * Optional returning/output clause.
     */
  }, {
    key: "output",
    value: function output(_output) {
      return this.returning(_output);
    }
    /**
     * Optional returning/output clause.
     */
  }, {
    key: "returning",
    value: function returning(_returning) {
      // not all databases support returning/output cause
      if (!this.connection.driver.isReturningSqlSupported("update")) {
        throw new ReturningStatementNotSupportedError();
      }
      this.expressionMap.returning = _returning;
      return this;
    }
    /**
     * Sets ORDER BY condition in the query builder.
     * If you had previously ORDER BY expression defined,
     * calling this function will override previously set ORDER BY conditions.
     */
  }, {
    key: "orderBy",
    value: function orderBy(sort) {
      var order = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ASC";
      var nulls = arguments.length > 2 ? arguments[2] : undefined;
      if (sort) {
        if (typeof sort === "object") {
          this.expressionMap.orderBys = sort;
        } else {
          if (nulls) {
            this.expressionMap.orderBys = _defineProperty({}, sort, {
              order: order,
              nulls: nulls
            });
          } else {
            this.expressionMap.orderBys = _defineProperty({}, sort, order);
          }
        }
      } else {
        this.expressionMap.orderBys = {};
      }
      return this;
    }
    /**
     * Adds ORDER BY condition in the query builder.
     */
  }, {
    key: "addOrderBy",
    value: function addOrderBy(sort) {
      var order = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ASC";
      var nulls = arguments.length > 2 ? arguments[2] : undefined;
      if (nulls) {
        this.expressionMap.orderBys[sort] = {
          order: order,
          nulls: nulls
        };
      } else {
        this.expressionMap.orderBys[sort] = order;
      }
      return this;
    }
    /**
     * Sets LIMIT - maximum number of rows to be selected.
     */
  }, {
    key: "limit",
    value: function limit(_limit) {
      this.expressionMap.limit = _limit;
      return this;
    }
    /**
     * Indicates if entity must be updated after update operation.
     * This may produce extra query or use RETURNING / OUTPUT statement (depend on database).
     * Enabled by default.
     */
  }, {
    key: "whereEntity",
    value: function whereEntity(entity) {
      var _this2 = this;
      if (!this.expressionMap.mainAlias.hasMetadata) throw new TypeORMError(".whereEntity method can only be used on queries which update real entity table.");
      this.expressionMap.wheres = [];
      var entities = Array.isArray(entity) ? entity : [entity];
      entities.forEach(function (entity) {
        var entityIdMap = _this2.expressionMap.mainAlias.metadata.getEntityIdMap(entity);
        if (!entityIdMap) throw new TypeORMError("Provided entity does not have ids set, cannot perform operation.");
        _this2.orWhereInIds(entityIdMap);
      });
      this.expressionMap.whereEntities = entities;
      return this;
    }
    /**
     * Indicates if entity must be updated after update operation.
     * This may produce extra query or use RETURNING / OUTPUT statement (depend on database).
     * Enabled by default.
     */
  }, {
    key: "updateEntity",
    value: function updateEntity(enabled) {
      this.expressionMap.updateEntity = enabled;
      return this;
    }
    // -------------------------------------------------------------------------
    // Protected Methods
    // -------------------------------------------------------------------------
    /**
     * Creates UPDATE express used to perform insert query.
     */
  }, {
    key: "createUpdateExpression",
    value: function createUpdateExpression() {
      var _this3 = this;
      var valuesSet = this.getValueSet();
      var metadata = this.expressionMap.mainAlias.hasMetadata ? this.expressionMap.mainAlias.metadata : undefined;
      // it doesn't make sense to update undefined properties, so just skip them
      var valuesSetNormalized = {};
      for (var key in valuesSet) {
        if (valuesSet[key] !== undefined) {
          valuesSetNormalized[key] = valuesSet[key];
        }
      }
      // prepare columns and values to be updated
      var updateColumnAndValues = [];
      var updatedColumns = [];
      if (metadata) {
        this.createPropertyPath(metadata, valuesSetNormalized).forEach(function (propertyPath) {
          // todo: make this and other query builder to work with properly with tables without metadata
          var columns = metadata.findColumnsWithPropertyPath(propertyPath);
          if (columns.length <= 0) {
            throw new EntityPropertyNotFoundError(propertyPath, metadata);
          }
          columns.forEach(function (column) {
            if (!column.isUpdate || updatedColumns.includes(column)) {
              return;
            }
            updatedColumns.push(column);
            //
            var value = column.getEntityValue(valuesSetNormalized);
            if (column.referencedColumn && typeof value === "object" && !(value instanceof Date) && value !== null && !Buffer.isBuffer(value)) {
              value = column.referencedColumn.getEntityValue(value);
            } else if (!(typeof value === "function")) {
              value = _this3.connection.driver.preparePersistentValue(value, column);
            }
            // todo: duplication zone
            if (typeof value === "function") {
              // support for SQL expressions in update query
              updateColumnAndValues.push(_this3.escape(column.databaseName) + " = " + value());
            } else if ((_this3.connection.driver.options.type === "sap" || _this3.connection.driver.options.type === "spanner") && value === null) {
              updateColumnAndValues.push(_this3.escape(column.databaseName) + " = NULL");
            } else {
              if (_this3.connection.driver.options.type === "mssql") {
                value = _this3.connection.driver.parametrizeValue(column, value);
              }
              var paramName = _this3.createParameter(value);
              var expression = null;
              if ((DriverUtils.isMySQLFamily(_this3.connection.driver) || _this3.connection.driver.options.type === "aurora-mysql") && _this3.connection.driver.spatialTypes.indexOf(column.type) !== -1) {
                var useLegacy = _this3.connection.driver.options.legacySpatialSupport;
                var geomFromText = useLegacy ? "GeomFromText" : "ST_GeomFromText";
                if (column.srid != null) {
                  expression = "".concat(geomFromText, "(").concat(paramName, ", ").concat(column.srid, ")");
                } else {
                  expression = "".concat(geomFromText, "(").concat(paramName, ")");
                }
              } else if (_this3.connection.driver.options.type === "postgres" && _this3.connection.driver.spatialTypes.indexOf(column.type) !== -1) {
                if (column.srid != null) {
                  expression = "ST_SetSRID(ST_GeomFromGeoJSON(".concat(paramName, "), ").concat(column.srid, ")::").concat(column.type);
                } else {
                  expression = "ST_GeomFromGeoJSON(".concat(paramName, ")::").concat(column.type);
                }
              } else if (_this3.connection.driver.options.type === "mssql" && _this3.connection.driver.spatialTypes.indexOf(column.type) !== -1) {
                expression = column.type + "::STGeomFromText(" + paramName + ", " + (column.srid || "0") + ")";
              } else {
                expression = paramName;
              }
              updateColumnAndValues.push(_this3.escape(column.databaseName) + " = " + expression);
            }
          });
        });
        // Don't allow calling update only with columns that are `update: false`
        if (updateColumnAndValues.length > 0 || Object.keys(valuesSetNormalized).length === 0) {
          if (metadata.versionColumn && updatedColumns.indexOf(metadata.versionColumn) === -1) updateColumnAndValues.push(this.escape(metadata.versionColumn.databaseName) + " = " + this.escape(metadata.versionColumn.databaseName) + " + 1");
          if (metadata.updateDateColumn && updatedColumns.indexOf(metadata.updateDateColumn) === -1) updateColumnAndValues.push(this.escape(metadata.updateDateColumn.databaseName) + " = CURRENT_TIMESTAMP"); // todo: fix issue with CURRENT_TIMESTAMP(6) being used, can "DEFAULT" be used?!
        }
      } else {
        Object.keys(valuesSetNormalized).map(function (key) {
          var value = valuesSetNormalized[key];
          // todo: duplication zone
          if (typeof value === "function") {
            // support for SQL expressions in update query
            updateColumnAndValues.push(_this3.escape(key) + " = " + value());
          } else if ((_this3.connection.driver.options.type === "sap" || _this3.connection.driver.options.type === "spanner") && value === null) {
            updateColumnAndValues.push(_this3.escape(key) + " = NULL");
          } else {
            // we need to store array values in a special class to make sure parameter replacement will work correctly
            // if (value instanceof Array)
            //     value = new ArrayParameter(value);
            var paramName = _this3.createParameter(value);
            updateColumnAndValues.push(_this3.escape(key) + " = " + paramName);
          }
        });
      }
      if (updateColumnAndValues.length <= 0) {
        throw new UpdateValuesMissingError();
      }
      // get a table name and all column database names
      var whereExpression = this.createWhereExpression();
      var returningExpression = this.createReturningExpression("update");
      if (returningExpression === "") {
        return "UPDATE ".concat(this.getTableName(this.getMainTableName()), " SET ").concat(updateColumnAndValues.join(", ")).concat(whereExpression); // todo: how do we replace aliases in where to nothing?
      }

      if (this.connection.driver.options.type === "mssql") {
        return "UPDATE ".concat(this.getTableName(this.getMainTableName()), " SET ").concat(updateColumnAndValues.join(", "), " OUTPUT ").concat(returningExpression).concat(whereExpression);
      }
      return "UPDATE ".concat(this.getTableName(this.getMainTableName()), " SET ").concat(updateColumnAndValues.join(", ")).concat(whereExpression, " RETURNING ").concat(returningExpression);
    }
    /**
     * Creates "ORDER BY" part of SQL query.
     */
  }, {
    key: "createOrderByExpression",
    value: function createOrderByExpression() {
      var _this4 = this;
      var orderBys = this.expressionMap.orderBys;
      if (Object.keys(orderBys).length > 0) return " ORDER BY " + Object.keys(orderBys).map(function (columnName) {
        if (typeof orderBys[columnName] === "string") {
          return _this4.replacePropertyNames(columnName) + " " + orderBys[columnName];
        } else {
          return _this4.replacePropertyNames(columnName) + " " + orderBys[columnName].order + " " + orderBys[columnName].nulls;
        }
      }).join(", ");
      return "";
    }
    /**
     * Creates "LIMIT" parts of SQL query.
     */
  }, {
    key: "createLimitExpression",
    value: function createLimitExpression() {
      var limit = this.expressionMap.limit;
      if (limit) {
        if (DriverUtils.isMySQLFamily(this.connection.driver) || this.connection.driver.options.type === "aurora-mysql") {
          return " LIMIT " + limit;
        } else {
          throw new LimitOnUpdateNotSupportedError();
        }
      }
      return "";
    }
    /**
     * Gets array of values need to be inserted into the target table.
     */
  }, {
    key: "getValueSet",
    value: function getValueSet() {
      if (typeof this.expressionMap.valuesSet === "object") return this.expressionMap.valuesSet;
      throw new UpdateValuesMissingError();
    }
  }]);
  return UpdateQueryBuilder;
}(QueryBuilder);